











import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { IObjectControllableFeature, ILinkedPageObjectSpecifiable, DateObjectKinds } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { FormatObjectSelectorColumnTypes } from "../../../../../formatEditor/components/format/editors/contents/commonComponents/selectors";
import { DateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";

@Component
export default class TranscribeDateOfTimeBehaviorEditor extends Mixins(ModelEditableMixin) {
  isEnable: boolean = false;

  @Prop()
  commonComponents: CommonComponentsContainer;

  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IObjectControllableFeature<ILinkedPageObjectSpecifiable>) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IObjectControllableFeature<ILinkedPageObjectSpecifiable>) => T, defaultValue: T) => T;

  get target(): ILinkedPageObjectSpecifiable {
    return this.readPropertyOrDefault(s => s.target, null);
  }

  set target(value: ILinkedPageObjectSpecifiable) {
    this.writePropertyWhenValid(s => {
      s.target = value;
      s.isEnable = this.isEnable;
    });
  }

  get dateObjects(): ILinkedPageObjectSpecifiable[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjectsForEachPage)
      .selectMany(p => Enumerable.from(p.objects)
        .select(o => o instanceof DateObjectEditor ? o : null)
        .where(o => !!o && !!o.name().getValue() && o.isDate().getValue() && o.objectKind().getValue() === DateObjectKinds.Normal)
        .select(o => {
          return {
            pageKey: p.pageKey,
            type: "date",
            id: o.id().getValue(),
            key: o.name().getValue(),
          };
        })
        .distinct(o => o.pageKey.toString() + " " + o.key)
        .toArray())
      .toArray();
  }

  async showTranscribeDateOfTimeEditDialog() {
    const dialog = this.commonComponents.getDialogs().getFormatObjectSingleSelectDialog();
    const selectedObject = await dialog.show(
      this.target,
      this.dateObjects,
      ["key", "pageNumber"],
      [],
      this.toCellString);
    if (selectedObject === undefined) { return; }
    this.isEnable = !!selectedObject;
    this.target = selectedObject;
  }

  private toCellString(column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable): string {
    switch (column) {
      case "key":
        return row.key;
      case "pageNumber":
        const pageNumber = this.commonComponents.getPageNumber(row.pageKey);
        return pageNumber === 0 ? "削除済" : pageNumber.toString();
      default:
        return "";
    }
  }
}
